import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { MatTooltipModule } from '@angular/material/tooltip';
import { IAlert } from 'src/app/core/dto';
import { TimeAgoPipe } from 'src/app/main/shared/pipes/basic.pipe';

@Component({
  selector: 'app-alert-warehouse-late',
  templateUrl: './alert-warehouse-late.component.html',
  styleUrls: ['./alert-warehouse-late.component.scss'],
  imports: [CommonModule, FlexLayoutModule, MatTooltipModule, TimeAgoPipe],
})
export class AlertWarehouseLateComponent {
  @Input() alert: IAlert = {} as IAlert;
}
